;(function () {
  'use strict';

  function globalnavtop() {
    $('.js-accordion__user-menu__button').hover(function () {
      $('.js-accordion__user-menu').addClass('is-show');
    }, function () {
      $('.js-accordion__user-menu').removeClass('is-show');
    });
  }

  function globalnavbottom() {
    $(".nav-global__bottom__category__acmenu").css({
      display: "none"
    }); // Opera Fix
    $(".nav-global__bottom__category").hover(function () {
      $(this).find('section:first').css({
        visibility: "visible",
        display: "none"
      }).show(400);
    }, function () {
      $(this).find('section:first').css({
        visibility: "hidden"
      });
    });
  }

  function searchresult() {
    $(".search-result-list li .item__menu").css({
      display: "none"
    }); // Opera Fix
    $(".search-result-list__item").hover(function () {
      $(this).find('.item__menu').css({
        visibility: "visible",
        display: "none"
      }).show(400);
    }, function () {
      $(this).find('.item__menu').css({
        visibility: "hidden"
      });
    });
  }

  function suggest() {
    $(".suggest-list li .item__menu ").css({
      display: "none"
    }); // Opera Fix
    $(".suggest-list__item ").hover(function () {
      $(this).find('.item__menu').css({
        visibility: "visible",
        display: "none"
      }).show(400);
    }, function () {
      $(this).find('.item__menu').css({
        visibility: "hidden"
      });
    });
  }

  /**
   * DOM content loaded
   */
  $(function () {
    globalnavtop();
    globalnavbottom();
    searchresult();
    suggest();
  });

}.call(this));
